import Sidebar from "../components/Sidebar/Sidebar";
// import Navbar from "../components/Navbar/Navbar";
import Loader from "../components/Loader/Loader";

import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { auth } from "../firebase/config";
import { getGymByUserId } from "../services/gymService";

import { GymContext } from "../context/GymContext";

import { deactivateExpiredSubscription } from "../services/gymService";

import "./DashboardLayout.css";

export default function DashboardLayout({ children }) {
  const [gym, setGym] = useState(null);
  const [loading, setLoading] = useState(true);

  const location = useLocation();

  useEffect(() => {
    loadGym();
  }, []);

  const loadGym = async () => {
    try {
      if (!auth.currentUser) {
        setLoading(false);
        return;
      }

      const data = await getGymByUserId(auth.currentUser.uid);

      setGym(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }

    const data = await getGymByUserId(auth.currentUser.uid);

    if (data?.subscriptionEndDate) {
      const today = new Date();

      const expiryDate = new Date(data.subscriptionEndDate);

      if (expiryDate < today) {
        await deactivateExpiredSubscription(data.id);

        data.subscriptionStatus = "Inactive";
      }
    }

    setGym(data);
  };

  if (loading) {
    return <Loader />;
  }

  // const today = new Date();

  // const isExpired =
  //   gym?.subscriptionEndDate && new Date(gym.subscriptionEndDate) < today;

  const path = location.pathname;

  let requiredFeature = null;

  if (path.startsWith("/attendance")) {
    requiredFeature = "attendance";
  } else if (path.startsWith("/qr-scanner")) {
    requiredFeature = "qrScanner";
  } else if (path.startsWith("/reports")) {
    requiredFeature = "reports";
  } else if (path.startsWith("/renewals")) {
    requiredFeature = "renewals";
  } else if (path.startsWith("/workout-plans")) {
    requiredFeature = "aiWorkout";
  } else if (path.startsWith("/diet-plans")) {
    requiredFeature = "dietPlan";
  }

  if (
    requiredFeature &&
    gym?.features &&
    gym.features[requiredFeature] === false
  ) {
    return <Navigate to="/access-denied" replace />;
  }

  return (
    <GymContext.Provider value={gym}>
      <div className="dashboard">
        <Sidebar />

        <div className="main-content">
          {/* <Navbar /> */}

          <div className="page-transition">{children}</div>
          <footer className="app-footer">Powered By NN FIT | © 2026</footer>
        </div>
      </div>
    </GymContext.Provider>
  );
}
